

import { getToken,  } from '@/utils/auth'
import { doDeleteProjectFile } from '@/api/enterprise'

export default {
  props: ['project_id'],      
  components: {
  },
  data() {
    return {
      saveLoading: false,
      fileList: [],
      attrDataList: [],
      fileDataList: [],
      uploadFileData: {},
      active: 0,
      widget: null,
      draw: null,
      predefineColors: [
        '#ff4500',
        '#ff8c00',
        '#ffd700',
        '#90ee90',
        '#00ced1',
        '#1e90ff',
        '#c71585',
        'rgba(255, 69, 0, 0.68)',
        'rgb(255, 120, 0)',
        'hsv(51, 100, 98)',
        'hsva(120, 40, 94, 0.5)',
        'hsl(181, 100%, 37%)',
        'hsla(209, 100%, 56%, 0.73)',
        '#c7158577'
      ],
      styleConfig: {
          lineStrokeColor: "#ff0000", // 线条的轮廓颜色
          lineBorderStyle: 0, // 线条的样式，实线、虚线等          
          lineOpacity: 100, // 线条的透明度
          opacity: 50,
          shapeFillColor: "#00ff00", // 形状的填充颜色
          shapeStrokeColor: "#ff0000", // 形状的轮廓颜色
          shapeStrokeColorOther: "", // 形状的轮廓颜色
          lineBorderWidth: 2, // 线条的宽度
          shapeBorderWidth: 1, // 形状的边框线宽度
          shareOpacity: 50, // 形状的透明度
          fontContent: "", // 文字的内容
          fontColor: "#ff0000", // 文字的颜色
          fontSize: 18, // 文字的大小
          fontOpacity: 0.8,
          pointRadius: 3, // 点大小，半径
          pointColor: "#00ff00", // 点颜色
          pointOpacity: 1,
      },
      borderStyles: [
        { id: 0, name: "实线", classest: "solid-line",  value: '' },
        { id: 1, name: "虚线", classest: "dashed-line", value: [0.2, 2] },
        { id: 2, name: "点线", classest: "dotted-line", value: [0.1, 2] },
      ], // 线条样式
      styleItems: [
        {
          label: '样式'
        },
        {
          label: '属性'
        },
        {
          label: '文件'
        }
      ]
    }
  },
  mounted() {
    this.widget = window.widget
    this.draw = window.widget.plotManager.draw 
  },
  methods: {
    getFileExtension(url) {
        var parts = url.split('/');
        var filename = parts.pop();
        return filename;
    },

    uploadFileSuccess(fileData) {      
      this.fileDataList = fileData.data.files.map( item => {
        return {
          fileName: item
        }
      })
    },
    getUploadFileData() {
      return {project_id: this.project_id}
    },
    getHeader() {
      return {token: getToken()}
    },
    changeStyle() {
        
        let styl = this.deepClone(this.styleConfig)
        styl.lineOpacity = styl.lineOpacity / 100
        styl.opacity = styl.opacity / 100
        styl.shareOpacity = styl.shareOpacity / 100
        styl.fontOpacity = styl.fontOpacity / 100
        styl.pointOpacity = styl.pointOpacity / 100
        $(`#sameDrawData_${this.project_id}`).data("styleConfig", JSON.stringify(styl));        
        $(`#sameDrawData_${this.project_id}`).click()               
        
    },
    sameNormal() {
        let styleConfig = null
        try {
          styleConfig = JSON.parse($(`#sameNormal_${this.project_id}`).data("styleConfig"));
        } catch (error) {
          
        }                    
        if (styleConfig) {
            this.setStyle(styleConfig)
        }
    },
    doEditSave() {
      // 取到当前的属性
      // 取到当前的文件
      // 取到当前的样式
      // 取到当前编辑的窗口
      this.saveLoading = true      
      setTimeout( () => {          
          $(`#editSave_${this.project_id}`).data('attrDataList',  JSON.stringify(this.attrDataList))
          $(`#saveDrawData_${this.project_id}`).click()
          this.saveLoading = false
      })
      
    },
    deepClone(obj) {
      let objClone = Array.isArray(obj) ? [] : {};
      if (obj && typeof obj === "object") {
        for (let key in obj) {
          if (obj[key] && typeof obj[key] === "object") {
            objClone[key] = this.deepClone(obj[key]);
          } else {
            objClone[key] = obj[key];
          }
        }
      }
      return objClone;
    },
    setStyle(style) {   
        let sty = this.deepClone(style)          
        if (sty instanceof Array) {
            this.styleConfig = {
                lineStrokeColor: "#ff0000", // 线条的轮廓颜色
                lineBorderStyle: 0, // 线条的样式，实线、虚线等          
                lineOpacity: 100, // 线条的透明度
                opacity: 50,
                shapeFillColor: "#00ff00", // 形状的填充颜色
                shapeStrokeColor: "#ff0000", // 形状的轮廓颜色
                shapeStrokeColorOther: "", // 形状的轮廓颜色
                lineBorderWidth: 2, // 线条的宽度
                shapeBorderWidth: 1, // 形状的边框线宽度
                shareOpacity: 50, // 形状的透明度
                fontContent: "", // 文字的内容
                fontColor: "#ff0000", // 文字的颜色
                fontSize: 18, // 文字的大小
                fontOpacity: 0.8,
                pointRadius: 3, // 点大小，半径
                pointColor: "#00ff00", // 点颜色
                pointOpacity: 1,
            }            
        } else {
            sty.lineOpacity = sty.lineOpacity * 100
            sty.opacity = sty.opacity * 100
            sty.shareOpacity = sty.shareOpacity * 100
            sty.fontOpacity = sty.fontOpacity * 100
            sty.pointOpacity = sty.pointOpacity * 100
            this.styleConfig = sty
        }
        
    },
    setFiles(files) {                     
        this.fileDataList = this.deepClone(files).map( item => {
        return {
          fileName: item
        }
      } )      
    },
    setAttribute(attrs) {                      
        this.attrDataList = this.deepClone(attrs)
    },

    delAttr(i) {
      this.attrDataList.splice(i, 1);
    },
    async delFile(i) {
      await doDeleteProjectFile({project_id: this.project_id, file_name: this.fileDataList[i].fileName})
      this.fileDataList.splice(i, 1);
    },
    addAttrOne() {
        this.attrDataList.push({
            attrName: '',
            attrValue: ''
        })
    },
    indexMethod(index) {
      return index + 1;
    },
    changeTab(index) {
        this.active = index
    },
  },
};
